import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roundTo10'
})
export class RoundTo10 implements PipeTransform {

    transform(value: any): number {
        // {{22/33|valueToPercentage}}
        try {
             return Math.round(+value / 10) * 10
        } catch (e) {

            return -1
        }
    }
}